(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bazic-main-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.bzReady) return;
    root.dataset.bzReady = '1';
    const q = s => root.querySelector(s), qa = s => Array.from(root.querySelectorAll(s));
    const main = q('[data-bz-main]');
    const fmt = (root.dataset.moneyFormat || '$' + '{' + '{amount}}').replace(/<[^>]*>/g, '');
    const group = (n, dec, th, sep) => { const [i, f] = n.toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? sep + f : ''); };
    const money = c => { const n = Math.round(c) / 100; return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) =>
      k === 'amount_no_decimals' ? group(n, 0, ',', '.') :
      k === 'amount_with_comma_separator' ? group(n, 2, '.', ',') :
      k === 'amount_no_decimals_with_comma_separator' ? group(n, 0, '.', ',') : group(n, 2, ',', '.')); };
    const variants = JSON.parse((q('[data-bz-variants]') || {}).textContent || '[]');
    const ppu = parseFloat(root.dataset.ppu) || 0, piece = root.dataset.piece || 'pen';
    const bundle = parseInt(root.dataset.bundle, 10) || 0;

    // Sticky bar reveals once the buy box is behind you.
    const topbar = q('[data-topbar]'), desc = q('[data-desc]');
    if(topbar){
      // Sit directly under the theme's sticky header instead of on top of it.
      // The header can collapse its navigation on scroll, so its bottom edge is measured live.
      const hdr = document.querySelector('header[is="sticky-header"]');
      const hdrBox = hdr ? (hdr.closest('.shopify-section') || hdr) : null;
      const headerBottom = () => {
        if(!hdrBox) return 0;
        const r = hdrBox.getBoundingClientRect();
        return r.bottom > 0 ? Math.round(r.bottom) : 0;
      };
      const onScroll = () => {
        const y = desc ? desc.getBoundingClientRect().top + window.scrollY - 80 : 340;
        topbar.style.top = window.matchMedia('(max-width: 749px)').matches ? '' : headerBottom() + 'px';
        topbar.classList.toggle('is-on', window.scrollY >= y);
      };
      window.addEventListener('scroll', onScroll, { passive:true });
      window.addEventListener('resize', onScroll);
      window.addEventListener('load', onScroll);
      topbar.addEventListener('click', e => { if(e.target.closest('[data-topbar-top]')){ e.preventDefault(); window.scrollTo({ top:0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); var mc=document.getElementById('MainContent'); if(mc){ try{ mc.focus({preventScroll:true}); }catch(_){ mc.focus(); } } } });
      onScroll();
    }

    // Gallery: hovering a thumb previews it, clicking keeps it and announces it.
    const galMain = q('[data-gal-main]'), galOpen = q('[data-zoom-open]'), galLive = q('[data-gal-live]');
    const thumbs = qa('[data-gal-src]');
    const showShot = (thumb, announce) => {
      const alt = thumb.dataset.alt || '';
      if(galMain){ galMain.src = thumb.dataset.galSrc; galMain.alt = alt; }
      if(galOpen) galOpen.setAttribute('aria-label', 'Enlarge image: ' + alt);
      thumbs.forEach(t => t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false'));
      if(announce && galLive) galLive.textContent = 'Showing image ' + (thumbs.indexOf(thumb) + 1) + ' of ' + thumbs.length + ': ' + alt;
    };
    thumbs.forEach(t => {
      t.addEventListener('mouseenter', () => { if(t.getAttribute('aria-pressed') !== 'true') showShot(t, false); });
      t.addEventListener('click', () => showShot(t, true));
    });

    // Lightbox: modal dialog, focus moves in, Tab is trapped, Escape closes, focus returns to the opener.
    const zoomBox = q('[data-zoom]');
    const zoomImg = zoomBox && zoomBox.querySelector('[data-zoom-img]');
    const zoomToggle = zoomBox && zoomBox.querySelector('[data-zoom-toggle]');
    const zoomClose = zoomBox && zoomBox.querySelector('[data-zoom-close]');
    let zoomReturn = null;
    const isOpen = () => zoomBox && zoomBox.style.display === 'flex';
    const setZoom = (on, ox, oy) => {
      zoomImg.style.transformOrigin = (ox ?? 50) + '% ' + (oy ?? 50) + '%';
      zoomImg.style.transform = on ? 'scale(2)' : 'scale(1)';
      zoomImg.style.cursor = on ? 'zoom-out' : 'zoom-in';
      zoomToggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      zoomToggle.setAttribute('aria-label', on ? 'Zoom out' : 'Zoom in 2x');
    };
    const openZoom = trigger => {
      zoomReturn = trigger;
      zoomImg.src = galMain.src.replace(/([?&])width=\d+/, '$1width=2400');
      zoomBox.setAttribute('aria-label', 'Enlarged image: ' + galMain.alt);
      setZoom(false);
      zoomBox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      zoomClose.focus();
      if(main) main.inert = true;
      if(topbar) topbar.inert = true;
    };
    const closeZoom = () => {
      zoomBox.style.display = 'none';
      document.body.style.overflow = '';
      if(main) main.inert = false;
      if(topbar) topbar.inert = false;
      setZoom(false);
      if(zoomReturn) zoomReturn.focus();
      zoomReturn = null;
    };
    if(galMain && galOpen && zoomBox && zoomImg && zoomToggle && zoomClose){
      galOpen.addEventListener('click', () => openZoom(galOpen));
      zoomClose.addEventListener('click', e => { e.stopPropagation(); closeZoom(); });
      zoomToggle.addEventListener('click', e => {
        e.stopPropagation();
        const keyboard = e.detail === 0;
        if(!keyboard && e.target !== zoomImg) return closeZoom();
        if(zoomToggle.getAttribute('aria-pressed') === 'true') return setZoom(false);
        if(keyboard) return setZoom(true);
        const r = zoomImg.getBoundingClientRect();
        setZoom(true, ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      });
      zoomBox.addEventListener('click', closeZoom);
      document.addEventListener('keydown', e => {
        if(!isOpen()) return;
        if(e.key === 'Escape'){ e.preventDefault(); closeZoom(); return; }
        if(e.key !== 'Tab') return;
        const f = [zoomClose, zoomToggle], i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      });
    }

    // Buy box: the inputs are the only state. Prices come from Shopify (cents).
    const form = q('form[action*="/cart/add"]');
    const qtyEl = q('[data-qty-val]'), freqEl = q('[data-freq-select]'), cta = q('[data-cta]');
    const getQty = () => Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    const selVariant = () => {
      const r = q('input[name="id"]:checked') || q('input[name="id"]');
      return variants.find(v => r && String(v.id) === r.value) || variants[0];
    };
    const setT = (s, t) => qa(s).forEach(el => { el.textContent = t; });

    const recalc = () => {
      const v = selVariant(); if(!v) return;
      const qty = getQty();
      const plans = v.plans || {};
      const subOk = Object.keys(plans).length > 0;
      const p = q('input[name="bz_plan"]:checked');
      const sub = subOk && !!freqEl && (!p || p.value === 'sub');
      const planId = freqEl ? freqEl.value : '';
      const firstPlan = freqEl ? (freqEl.querySelector('option[value]:not([value=""])') || {}).value : '';
      const previewId = planId || firstPlan;
      const pOpt = previewId && freqEl ? freqEl.querySelector('option[value="' + previewId + '"]') : null;

      const one = v.price * qty;
      const subPrice = (plans[previewId] != null ? plans[previewId] : v.price) * qty;
      const pens = v.units * ppu * qty;
      const pct = pOpt && pOpt.dataset.pct ? parseFloat(pOpt.dataset.pct) : Math.round((1 - subPrice / one) * 100);

      setT('[data-sub-pill]', 'Save ' + pct + '%');
      setT('[data-sub-price]', money(subPrice));
      setT('[data-sub-save]', money(one - subPrice));
      if(pOpt) setT('[data-sub-every]', pOpt.dataset.every);
      setT('[data-one-price]', money(one));
      if(pens){ setT('[data-sub-per]', money(subPrice / pens) + ' per ' + piece); setT('[data-one-per]', money(one / pens) + ' per ' + piece); }

      const rows = qa('[data-addon] input[type="checkbox"]');
      const on = rows.filter(r => r.checked);
      let extras = on.reduce((s, a) => s + (parseInt(a.dataset.price, 10) || 0), 0);
      if(bundle && rows.length > 1 && on.length === rows.length) extras -= bundle;

      const total = (sub && planId ? subPrice : one) + extras;
      setT('[data-add-total]', money(total));
      if(freqEl) freqEl.disabled = !sub;
      setT('[data-sku]', v.sku || '');

      const needsFreq = sub && !planId, sold = !v.available, off = needsFreq || sold;
      setT('[data-cta-label]', sold ? 'Sold out' : needsFreq ? 'Choose a frequency' : 'Add to cart');
      qa('[data-cta-sep],[data-add-total]').forEach(el => { el.style.display = off ? 'none' : ''; });
      if(cta) cta.setAttribute('aria-disabled', off ? 'true' : 'false');
    };

    // Variants without selling plans hide the purchase-type group and fall back to one-time.
    const syncPlanGroup = () => {
      const v = selVariant();
      const ok = !!v && Object.keys(v.plans || {}).length > 0;
      const grp = q('[data-plan]');
      if(grp) grp.hidden = !ok;
      if(!ok){ const one = q('input[name="bz_plan"][value="one"]'); if(one) one.checked = true; }
    };

    const onVariant = () => {
      const v = selVariant(); if(!v) return;
      syncPlanGroup();
      if(v.media){ const t = thumbs.find(t => t.dataset.mediaId === String(v.media)); if(t) showShot(t, false); }
      // Add-on pools: unit pool for single units and sets, box pool for boxes. Hidden rows are unchecked.
      const pools = qa('[data-addon-pool]');
      if(pools.length > 1){
        const isBox = (v.units || 1) > 1;
        pools.forEach(p => {
          const show = (p.dataset.addonPool === 'box') === isBox;
          p.hidden = !show;
          if(!show) p.querySelectorAll('input').forEach(i => { i.checked = false; });
        });
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };

    if(form){
      form.addEventListener('change', e => {
        const t = e.target;
        if(t.name === 'id'){ onVariant(); recalc(); }
        else if(t === qtyEl){ qtyEl.value = getQty(); recalc(); }
        else recalc();
      });
      if(qtyEl) qtyEl.addEventListener('input', recalc);
      qa('[data-qty]').forEach(btn => btn.addEventListener('click', () => {
        qtyEl.value = Math.max(1, getQty() + (parseInt(btn.dataset.qty, 10) || 0));
        recalc();
      }));
      // Add to cart through the Ajax Cart API, then open the theme's cart drawer.
      // Add-ons ride in the same request. Without a drawer the page falls back to the cart page.
      const errEl = q('[data-cart-error]');
      const showErr = msg => { if(errEl){ errEl.textContent = msg; errEl.hidden = !msg; } };
      form.addEventListener('submit', async e => {
        if(cta && cta.getAttribute('aria-disabled') === 'true'){ e.preventDefault(); return; }
        const drawer = document.querySelector('cart-drawer');
        const rebuy = window.Rebuy && window.Rebuy.SmartCart ? window.Rebuy : null;
        const adds = qa('[data-addon] input:checked');
        if(!rebuy && !drawer && !adds.length) return;
        e.preventDefault();
        showErr('');
        const v = selVariant();
        const item = { id: v.id, quantity: getQty() };
        if(freqEl && !freqEl.disabled && freqEl.value) item.selling_plan = Number(freqEl.value);
        if(cta){ cta.setAttribute('aria-busy', 'true'); cta.setAttribute('aria-disabled', 'true'); }
        try{
          const r = await fetch(root.dataset.cartAddUrl + '.js', {
            method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
            body: JSON.stringify({ items: [item].concat(adds.map(a => ({ id: Number(a.value), quantity: 1 }))) })
          });
          const data = await r.json().catch(() => ({}));
          if(!r.ok) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
          adds.forEach(a => { a.checked = false; });
          recalc();
          if(rebuy){
            // Rebuy Smart Cart keeps its own copy of the cart: refresh it, then open it.
            await new Promise(res => {
              let done = false; const finish = () => { if(!done){ done = true; res(); } };
              try{
                const C = rebuy.Cart;
                const out = C && typeof C.fetchShopifyCart === 'function' ? C.fetchShopifyCart(finish) : null;
                if(out && typeof out.then === 'function') out.then(finish, finish); else if(!C) finish();
              }catch(_){ finish(); }
              setTimeout(finish, 1500);
            });
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail:{ open:false } }));
            rebuy.SmartCart.show();
          } else if(drawer){
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail:{ open:true } }));
          } else {
            window.location.href = root.dataset.cartUrl;
          }
        }catch(err){
          showErr(err.message || 'This item could not be added to your cart.');
        }finally{
          if(cta){ cta.removeAttribute('aria-busy'); cta.setAttribute('aria-disabled', v.available ? 'false' : 'true'); }
        }
      });
    }

    // Accordion: one row open at a time, first open on load.
    const faqRows = qa('[data-faq]');
    let faqOpen = null;
    const setFaq = row => {
      faqOpen = row;
      faqRows.forEach(r => {
        const open = r === row;
        const btn = r.querySelector('[data-faq-btn]'), panel = r.querySelector('[data-faq-panel]'), ico = r.querySelector('[data-faq-ico]');
        if(btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if(panel){
          const ph = panel.firstElementChild ? panel.firstElementChild.offsetHeight : 0;
          panel.style.maxHeight = open ? (ph ? ph + 'px' : '600px') : '0px';
          panel.style.transitionDelay = open ? '0s, 0s' : '0s, 180ms';
          panel.style.visibility = open ? 'visible' : 'hidden';
        }
        if(ico) ico.textContent = open ? '\u2013' : '+';
      });
    };
    const remeasure = () => { if(faqOpen) setFaq(faqOpen); };
    faqRows.forEach(r => {
      const btn = r.querySelector('[data-faq-btn]');
      if(btn) btn.addEventListener('click', () => setFaq(btn.getAttribute('aria-expanded') === 'true' ? null : r));
    });
    if(faqRows.length){
      setFaq(faqRows[0]);
      requestAnimationFrame(remeasure);
      window.addEventListener('load', remeasure);
      window.addEventListener('resize', remeasure);
      if(document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    }

    syncPlanGroup();
    recalc();
  }
  const boot = () => document.querySelectorAll('[data-bz-pdp]').forEach(init);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-bz-pdp]')));
})();

  } catch(e) { console.error(e); }
})();
})();
